import actionTypes from '../constants/action-types';

const setSiteCustomization = (siteCustomizationConfig) => ({
  type: actionTypes.SET_SITE_CUSTOMIZATION,
  payload: {
    siteCustomizationConfig,
  },
});

export default setSiteCustomization;
